"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNumberDescription = exports.numberDescription = void 0;
const exists_1 = __importDefault(require("../util/exists"));
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
function numberDescription(details = {}) {
    return Object.assign({ userFacingTitle: 'number', userFacingValue: String, validate: function (value) {
            if (typeof value !== 'number') {
                if (details.allowStringValues) {
                    value = Number(value);
                }
                else {
                    return new InvalidResult_1.default(`Not a number: ${value}`);
                }
            }
            if (isNaN(value)) {
                return new InvalidResult_1.default(`Not a number: ${value}`);
            }
            if ((0, exists_1.default)(this.minimumValue) && value < this.minimumValue) {
                return new InvalidResult_1.default(`${value} is less than minimum amount (${this.minimumValue})`);
            }
            if ((0, exists_1.default)(this.maximumValue) && value > this.maximumValue) {
                return new InvalidResult_1.default(`${value} is greater than maximum amount (${this.maximumValue})`);
            }
            return value;
        } }, details);
}
exports.numberDescription = numberDescription;
exports.defaultNumberDescription = numberDescription();
